module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-main"
  }, [(_vm.props.app) ? _c('div', {
    staticClass: "footer-main__bg"
  }, [_c('div', {
    staticClass: "footer-main__container"
  }, [_c('div', {
    staticClass: "footer-main__contact"
  }, [_c('h4', [_vm._v("Two Convenient Locations:")]), _c('div', {
    staticClass: "footer-main__contact-box"
  }, [_c('a', {
    staticClass: "notranslate footer-main__contact--section",
    attrs: {
      "href": _vm.props.app.information.address_href
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.address)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": "tel:" + _vm.props.app.information.phone,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.phone_display)
    }
  }), _c('div', {
    staticClass: "footer-main__social-linkslocation"
  }, _vm._l((_vm.props.app.information.social_links_henderson), function(socialHenderson) {
    return _c('a', {
      staticClass: "footer-main__social-linklocation",
      attrs: {
        "href": socialHenderson.link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "footer-main__social-icon",
      attrs: {
        "title": socialHenderson.icon.title,
        "src": socialHenderson.icon.url,
        "alt": socialHenderson.icon.alt
      }
    })])
  })), _c('hr'), _c('a', {
    staticClass: "notranslate footer-main__contact--section",
    attrs: {
      "href": _vm.props.app.information.address_href_copy
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.address_copy)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": "tel:" + _vm.props.app.information.phone_copy,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.phone_display_copy)
    }
  }), _c('div', {
    staticClass: "footer-main__social-linkslocation"
  }, _vm._l((_vm.props.app.information.social_links_summerlin), function(socialSummerlin) {
    return _c('a', {
      staticClass: "footer-main__social-linklocation",
      attrs: {
        "href": socialSummerlin.link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "footer-main__social-icon",
      attrs: {
        "title": socialSummerlin.icon.title,
        "src": socialSummerlin.icon.url,
        "alt": socialSummerlin.icon.alt
      }
    })])
  }))])]), _c('div', {
    staticClass: "footer-main__logo"
  }, [_c('Icon', {
    attrs: {
      "name": "logo-3"
    }
  }), (_vm.props.app.information.celebrate_logo) ? _c('img', {
    staticClass: "footer-main__celebrate-logo",
    attrs: {
      "title": _vm.props.app.information.celebrate_logo.title,
      "src": _vm.props.app.information.celebrate_logo.url,
      "alt": _vm.props.app.information.celebrate_logo.alt
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "footer-main__trademarks"
  }, [_c('div', {
    staticClass: "footer-main__right"
  }, [_c('div', {
    staticClass: "footer-main__links"
  }, [_c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": _vm.props.app.information.xray_link,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.xray_link_text)
    }
  }), _c('br'), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": _vm.props.app.information.referral_link,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.referral_link_text)
    }
  }), _c('br'), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": _vm.props.app.information.informed_consent_link,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.informed_consent_link_text)
    }
  })]), (_vm.props.app.information.phone_hours) ? _c('div', {
    staticClass: "footer-main__phone",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.phone_hours)
    }
  }) : _vm._e(), (_vm.props.app.information.working_hours) ? _c('div', {
    staticClass: "footer-main__hours",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.working_hours)
    }
  }) : _vm._e(), _c('br'), _c('a', {
    staticClass: "footer-main__contact--section footer-main__contact--section-doc",
    attrs: {
      "href": _vm.props.app.information.doc_link,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.doc_display)
    }
  }), _c('div', {
    staticClass: "footer-main__social-links"
  }, _vm._l((_vm.props.app.information.social_links), function(social) {
    return _c('a', {
      staticClass: "footer-main__social-link",
      attrs: {
        "href": social.link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "footer-main__social-icon",
      attrs: {
        "title": social.icon.title,
        "src": social.icon.url,
        "alt": social.icon.alt
      }
    })])
  })), _c('div', {
    staticClass: "footer-main__copyright"
  }, [_c('a', {
    staticClass: "footer-main__roostergrin",
    attrs: {
      "target": "_blank",
      "href": "https://roostergrin.com",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.trademark)
    }
  }), _c('a', {
    staticClass: "footer-main__privacy",
    attrs: {
      "href": _vm.props.app.information.privacy_link,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.information.privacy)
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f49bb4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 645
// module chunks = 1